import { useMantineTheme } from "@mantine/core"
import { SVGProps } from "react"

type Props = {
  hovered: boolean
  size?: number
} & SVGProps<SVGSVGElement>

export const IconMultipleNavion = ({ hovered, ...props }: Props) => {
  const theme = useMantineTheme()

  if (hovered)
    return (
      <IconMultipleNavionHovered fill={theme.colors.primary[6]} {...props} />
    )
  else
    return (
      <IconMultipleNavionDefault fill={theme.colors.primary[6]} {...props} />
    )
}

const IconMultipleNavionHovered = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      id="b"
      data-name="Calque 2"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 8.23 6.88"
      width={22}
      height={22}
      {...props}
    >
      <g id="c" data-name="Calque 1">
        <path d="m6.82,5.27s-.05-.02-.08,0l-1.85.74s-.08.06-.07.11c0,.05.04.09.09.1l.69.19.02.34s.03.08.08.09c.01,0,.03,0,.04,0,.03,0,.06-.01.09-.04l.17-.17.34.21s.04.02.07.02c.01,0,.03,0,.04,0,.04-.01.07-.04.07-.08l.33-1.45s0-.05-.03-.07Zm-.35.25l-.82.76-.62-.17,1.44-.58Zm-.71,1.15v-.18s.1.07.1.07l-.1.1Zm.61.05l-.59-.38.86-.79-.27,1.16Z" />
        <path d="m3.12,3.44s-.08-.03-.12-.02L.11,4.59c-.07.03-.12.1-.11.17,0,.07.06.14.13.16l1.08.3.03.54c0,.07.05.12.12.15.02,0,.04,0,.06,0,.05,0,.1-.02.13-.06l.27-.27.53.34s.07.03.11.03c.02,0,.05,0,.07-.01.06-.02.1-.07.12-.13l.52-2.27s0-.08-.04-.11Zm-.55.39l-1.28,1.18-.98-.27,2.26-.91Zm-1.1,1.79l-.02-.28.18.11-.16.16Zm.96.08l-.92-.59,1.34-1.23-.42,1.82Z" />
        <path
          d="m8.1.1c-.07-.05-.16-.06-.23-.03L2.27,2.32c-.14.06-.23.19-.22.33,0,.14.11.26.26.3l2.09.58.06,1.04c0,.13.1.24.23.29.04.01.08.02.12.02.1,0,.19-.04.26-.11l.52-.53,1.02.65c.06.04.13.06.21.06.04,0,.09,0,.14-.02.11-.04.2-.13.22-.24L8.18.3c.02-.08-.01-.16-.08-.21Zm-1.06.76l-2.48,2.28-1.89-.53L7.04.86Zm-2.14,3.47l-.03-.53.34.22-.31.32Zm1.85.16l-1.78-1.14L7.56.96l-.81,3.52Z"
          strokeMiterlimit={10}
          strokeWidth={0.1}
        />
      </g>
    </svg>
  )
}

const IconMultipleNavionDefault = (props: SVGProps<SVGSVGElement>) => (
  <svg
    id="b"
    data-name="Calque 2"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 8.23 6.88"
    width={22}
    height={22}
    {...props}
  >
    <g id="c" data-name="Calque 1">
      <path d="m6.82,5.27s-.05-.02-.08,0l-1.85.74s-.08.06-.07.11c0,.05.04.09.09.1l.69.19.02.34s.03.08.08.09c.01,0,.03,0,.04,0,.03,0,.06-.01.09-.04l.17-.17.34.21s.04.02.07.02c.01,0,.03,0,.04,0,.04-.01.07-.04.07-.08l.33-1.45s0-.05-.03-.07Zm-.35.25l-.82.76-.62-.17,1.44-.58Zm-.71,1.15v-.18s.1.07.1.07l-.1.1Zm.61.05l-.59-.38.86-.79-.27,1.16Z" />
      <path d="m3.12,3.44s-.08-.03-.12-.02L.11,4.59c-.07.03-.12.1-.11.17,0,.07.06.14.13.16l1.08.3.03.54c0,.07.05.12.12.15.02,0,.04,0,.06,0,.05,0,.1-.02.13-.06l.27-.27.53.34s.07.03.11.03c.02,0,.05,0,.07-.01.06-.02.1-.07.12-.13l.52-2.27s0-.08-.04-.11Zm-.55.39l-1.28,1.18-.98-.27,2.26-.91Zm-1.1,1.79l-.02-.28.18.11-.16.16Zm.96.08l-.92-.59,1.34-1.23-.42,1.82Z" />
      <path
        d="m8.1.1c-.07-.05-.16-.06-.23-.03L2.27,2.32c-.14.06-.23.19-.22.33,0,.14.11.26.26.3l2.09.58.06,1.04c0,.13.1.24.23.29.04.01.08.02.12.02.1,0,.19-.04.26-.11l.52-.53,1.02.65c.06.04.13.06.21.06.04,0,.09,0,.14-.02.11-.04.2-.13.22-.24L8.18.3c.02-.08-.01-.16-.08-.21Zm-1.06.76l-2.48,2.28-1.89-.53L7.04.86Zm-2.14,3.47l-.03-.53.34.22-.31.32Zm1.85.16l-1.78-1.14L7.56.96l-.81,3.52Z"
        strokeMiterlimit={10}
        strokeWidth={0.1}
      />
    </g>
  </svg>
)
